import React, {
    useEffect,
    useState
} from "react";

import {
    FaBars,
    FaUser,
    FaCog,
    FaSignOutAlt
} from "react-icons/fa";

import {
    useNavigate
} from "react-router-dom";

import Swal from "sweetalert2";

import API_BASE_URL from "../config/api.js";

import checkLogin from "../config/checkLogin";


function Header({ toggleSidebar }) {


    const [showMenu, setShowMenu] =
        useState(false);

    const [loading, setLoading] =
        useState(false);


    const navigate =
        useNavigate();


    /*
    |--------------------------------------------------------------------------
    | Check Admin Login
    |--------------------------------------------------------------------------
    */

    useEffect(() => {


        const verifyLogin = async () => {


            const isLoggedIn =
                await checkLogin();


            if (!isLoggedIn) {


                navigate("/login", {
                    replace: true
                });


                return;

            }


        };


        verifyLogin();


    }, [navigate]);


    /*
    |--------------------------------------------------------------------------
    | Logout
    |--------------------------------------------------------------------------
    */

    const handleLogout = async () => {


        if (loading) {

            return;

        }


        try {


            setLoading(true);


            const response =
                await fetch(
                    `${API_BASE_URL}/admin/logout`,
                    {
                        method: "POST",

                        headers: {
                            "Accept":
                                "application/json"
                        },

                        credentials:
                            "include"
                    }
                );


            console.log(
                "Logout Response Status:",
                response.status
            );


            const data =
                await response.json();


            console.log(
                "Logout Response:",
                data
            );


            /*
            |--------------------------------------------------------------------------
            | Logout Successful
            |--------------------------------------------------------------------------
            */

            if (response.ok) {


                setShowMenu(false);


                await Swal.fire({

                    icon: "success",

                    title: "Logout Successful",

                    text:
                        "You have been logged out successfully.",

                    timer: 1500,

                    showConfirmButton: false

                });


                /*
                |--------------------------------------------------------------------------
                | Go To Login
                |--------------------------------------------------------------------------
                */

                navigate("/login", {
                    replace: true
                });


                return;

            }


            /*
            |--------------------------------------------------------------------------
            | Logout Failed
            |--------------------------------------------------------------------------
            */

            Swal.fire({

                icon: "error",

                title: "Logout Failed",

                text:
                    data.message ||
                    "Unable to logout. Please try again."

            });


        } catch (error) {


            console.error(
                "Logout Error:",
                error
            );


            Swal.fire({

                icon: "error",

                title: "Connection Error",

                text:
                    "Unable to connect with Laravel server."

            });


        } finally {


            setLoading(false);


        }

    };


    return (


        <div className="header">


            {/* --------------------------------------------------------------
                Left Header
            -------------------------------------------------------------- */}

            <div className="left-header">


                <button
                    className="menu-btn"
                    onClick={toggleSidebar}
                >

                    <FaBars />

                </button>


                <h4>
                    HomeoAdda Admin
                </h4>


            </div>



            {/* --------------------------------------------------------------
                Profile
            -------------------------------------------------------------- */}

            <div className="profile-wrapper">


                <div
                    className="profile-info"

                    onClick={() =>
                        setShowMenu(
                            !showMenu
                        )
                    }
                >


                    <img
                        src="https://i.pravatar.cc/150?img=12"
                        alt="Admin"
                    />


                    <span>
                        Anil Saini
                    </span>


                </div>



                {/* ----------------------------------------------------------
                    Profile Menu
                ---------------------------------------------------------- */}

                {showMenu && (


                    <div className="profile-menu">


                        <button
                            type="button"
                        >

                            <FaUser />

                            <span>
                                Profile
                            </span>

                        </button>



                        <button
                            type="button"
                        >

                            <FaCog />

                            <span>
                                Settings
                            </span>

                        </button>



                        {/* --------------------------------------------------
                            Logout
                        -------------------------------------------------- */}

                        <button
                            type="button"

                            onClick={handleLogout}

                            disabled={loading}
                        >


                            <FaSignOutAlt />


                            <span>

                                {loading
                                    ? "Logging out..."
                                    : "Logout"
                                }

                            </span>


                        </button>


                    </div>

                )}


            </div>


        </div>

    );

}


export default Header;
